import { Injectable } from '@angular/core';
import { Observable, of, delay, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ApiResponse } from '../../../../core/models/auth.models';

export interface TomoDashboardOrder {
    idOrder: number;
    codOrder: string;
    patientCi: string;
    patientName: string;
    idBranch: number;
    branchName: string;
    tomoStudyCount: number;
    statusCode: string;
    statusDescription: string;
}

export interface TomoDashboardBranch {
    idBranch: number;
    branchName: string;
    orderCount: number;
    studyCount: number;
}

export interface TomoDashboard {
    totalOrders: number;
    totalStudies: number;
    orders: TomoDashboardOrder[];
    branches: TomoDashboardBranch[];
}

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private apiUrl = environment.apiUrl;
    private headers!: HttpHeaders;

    constructor(private http: HttpClient) {}

    // Obtener los datos de las órdenes emitidas hoy
    getDatosStatsWidgets(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}dashboards/stats_widgets_usr`);
    }

    // Obtener los datos de las órdenes emitidas hoy
    getDatosGraphBranches(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}dashboards/graph_branches`);
    }

    /** Órdenes de hoy con al menos un estudio TOMO (todas las sucursales) y su conteo por sucursal. */
    getTomoToday(): Observable<ApiResponse<TomoDashboard>> {
        return this.http.get<ApiResponse<TomoDashboard>>(`${this.apiUrl}medical-reports/dashboard/today`);
    }
}
